<template>
  <div class="my-integral-info ios-padding-bottom">
    <div class="my-integral-header">
      <img src="../../picture/integral/bg.png" class="integral-bg" />
      <div class="my-integral-header-box">
        <div class="my-integral-title">当前积分</div>
        <div class="my-integral-number">{{ pointsData.points || 0 }}</div>
        <div class="my-integral-details" @click="integralDetails">积分明细</div>
      </div>
    </div>

    <div class="integral-exchange-content" v-if="exchangeAllList.length > 0">
      <div class="exchange-title-box">
        <div class="integral-exchange-title">积分兑换</div>
      </div>

      <div class="integral-exchange-list-box">
        <pi-tabs
          type="border"
          :list="tabsList"
          :active="tabs"
          @change="tabsClick"
        ></pi-tabs>
        <div
          class="integral-exchange-list"
          v-if="exchangeShowData.userPriceParams"
        >
          <div
            class="integral-exchange-item"
            v-for="(item, index) in exchangeShowData.userPriceParams"
            :key="index"
          >
            <div class="v-center">
              <img
                src="../../picture/integral/vip-1.png"
                v-if="exchangeShowData.vipLevel == 1"
                class="exchange-icon"
                alt=""
              />
              <img
                src="../../picture/integral/vip-2.png"
                v-else-if="exchangeShowData.vipLevel == 2"
                class="exchange-icon"
                alt=""
              />
              <img
                src="../../picture/integral/vip-3.png"
                v-else-if="exchangeShowData.vipLevel == 3"
                class="exchange-icon"
                alt=""
              />
              <img
                src="../../picture/integral/vip-4.png"
                v-else-if="exchangeShowData.vipLevel == 4"
                class="exchange-icon"
                alt=""
              />
            </div>
            <div class="exchange-flex">
              <div class="flex-title">
                {{ exchangeShowData.vipName }}{{ item.days }}天
              </div>
              <div class="flex-value">{{ item.points }}积分</div>
            </div>
            <div class="v-center">
              <div
                class="exchange-btn v-center"
                :class="pointsData.points >= item.points ? '' : 'default'"
                @click="goExchange(item)"
              >
                <img
                  src="../../picture/integral/btn-icon.png"
                  class="exchange-btn-icon"
                  alt=""
                />
                兑换
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pi-no-list-data :list="exchangeAllList" text="暂无积分兑换活动">
      <img src="../../picture/no-data-icon/integral.png" class="no-list-icon" />
    </pi-no-list-data>
  </div>
</template>
<script>
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
import piTabs from "@/components/pi-tabs/pi-tabs.vue";

import {
  getUserPoints,
  getCampaignUnderway,
  getUserVipByPoints,
} from "../../common/api";

export default {
  name: "my-integral-info",
  components: {
    [noListData.name]: noListData,
    [piTabs.name]: piTabs,
  },
  data() {
    return {
      pointsData: {},
      activityData: null,
      tabsList: [],
      tabs: "0",
      exchangeAllList: [],
      exchangeShowData: {},
    };
  },
  mounted() {
    this.getUserPoints();
    this.getCampaignUnderway();
    this.getUserVipByPoints();
  },
  methods: {
    /**
     * 积分明细
     */
    integralDetails() {
      this.$router.push("/my-integral-record");
    },
    /**
     * 兑换点击
     * @param {} e
     */
    goExchange(item) {
      if (this.pointsData.points >= item.points) {
        this.$common.save("exchange-details", {
          data: this.exchangeShowData,
          child: item,
        });
        this.$router.push(
          "/my-exchange?chargeUserPkId=" + this.$route.query.chargeUserPkId
        );
      }
    },
    /**
     * 获取积分信息
     */
    async getUserPoints() {
      let ret = await getUserPoints({});
      if (ret.status === this.$config.ajaxStatus) {
        let data = ret.data[0];
        this.pointsData = data;
      } else {
        this.$toast(ret.msg);
      }
    },
    /**
     * 获取活动规则
     */
    async getCampaignUnderway() {
      let ret = await getCampaignUnderway({
        oprPkId: this.$oprPkId,
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.activityData = ret.data[0] || {};
      } else {
        this.$toast(ret.msg);
      }
    },
    /**
     * 获取兑换列表
     */
    async getUserVipByPoints() {
      let ret = await getUserVipByPoints({});
      if (ret.status === this.$config.ajaxStatus) {
        let data = ret.data || [];
        this.forPointsData(data);
      } else {
        this.$toast(ret.msg);
      }
    },
    /**
     * 处理兑换列表数据
     */
    forPointsData(data) {
      let tabsList = [];
      let tabs = "";
      if (data.length > 0) {
        data.map((item) => {
          tabsList.push({ name: item.vipName, value: item.vipPkId });
        });
        tabs = data[0].vipPkId;
      }
      this.exchangeAllList = data;
      this.tabsList = tabsList;
      this.tabs = tabs;
      this.exchangeShowData = data[0] || {};
    },
    /**
     * tabs 切换点击
     * @param {*} e
     */
    tabsClick(data) {
      var vipPkId = data.value;
      let exchangeShowData = this.exchangeAllList.filter((item) => {
        return item.vipPkId == vipPkId;
      });
      this.tabs = vipPkId;
      this.exchangeShowData = exchangeShowData[0];
    },
  },
};
</script>
<style lang="less" scoped>
.my-integral-info {
  min-height: 100%;
  background-color: #f5f4f9;
}
.my-integral-header {
  background-color: #14cc80;
  color: #fff;
  position: relative;
  height: 1.96rem;
}
.my-integral-header .integral-bg {
  width: 100%;
  height: 100%;
}
.my-integral-header .my-integral-header-box {
  padding: 0.36rem 0 0.55rem 0;
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  left: 0;
  top: 0;
}
.my-integral-header .my-integral-header-box .my-integral-title {
  font-size: 0.28rem;
  height: 0.4rem;
}
.my-integral-header .my-integral-header-box .my-integral-number {
  font-size: 0.5rem;
  height: 0.6rem;
  margin-top: 0.05rem;
}
.my-integral-header .my-integral-header-box .my-integral-details {
  font-size: 0.24rem;
  height: 0.33rem;
  position: absolute;
  right: 0.3rem;
  top: 0.3rem;
  text-decoration: underline;
}
.integral-exchange-content .exchange-title-box {
  display: flex;
  line-height: 0.4rem;
  padding: 0.2rem;
}
.integral-exchange-content .exchange-title-box .integral-exchange-title {
  font-size: 0.28rem;
  font-size: #333;
  flex: 1;
}

.integral-exchange-content .integral-exchange-list-box {
  background-color: #fff;
}
.integral-exchange-content .integral-exchange-list {
  border-top: 0.01rem solid #eeeeee;
}

.integral-exchange-content .integral-exchange-list .integral-exchange-item {
  display: flex;
  height: 1.04rem;
  padding: 0 0.3rem;
  margin-top: 0.3rem;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .exchange-icon {
  width: 1rem;
  height: 1rem;
  vertical-align: top;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .exchange-flex {
  flex: 1;
  padding-left: 0.2rem;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .flex-title {
  color: #000;
  padding-top: 0.06rem;
  font-size: 0.32rem;
  line-height: 0.45rem;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .flex-value {
  margin-top: 0.1rem;
  font-size: 0.24rem;
  line-height: 0.33rem;
  color: #999999;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .exchange-btn {
  width: 1.8rem;
  height: 0.7rem;
  background: linear-gradient(137deg, #fad961 0%, #ffa244 100%, #ffa244 100%);
  border-radius: 0.4rem;
  font-size: 0.36rem;
  line-height: 0.5rem;
  color: #fff;
}
.integral-exchange-content
  .integral-exchange-list
  .integral-exchange-item
  .exchange-btn-icon {
  width: 0.38rem;
  height: 0.38rem;
  vertical-align: middle;
}
.exchange-btn.default {
  opacity: 0.5;
}
</style>